import { createAction } from '@reduxjs/toolkit';
import { ISaveSubscriptionProps } from 'reactApp/components/VkBuyModalWithSidebar/SaveSubscriptionSidebar/SaveSubscriptionSidebar';
import { OpenFastCheckoutAction, OpenPromocodeGiftModalAfterBuyAction } from 'reactApp/modules/payment/payment.types';

export const openFastCheckout = createAction<OpenFastCheckoutAction>('payment/openFastCheckout');
export const openPromocodeGiftModalAfterBuy = createAction<OpenPromocodeGiftModalAfterBuyAction>('payment/openPromocodeGiftModalAfterBuy');
export const openSaveSubscriptionPayment = createAction<ISaveSubscriptionProps>('payment/openSaveSubscriptionPayment');
